import { useSearchDispatch, useSearchStoreContext } from "PFApp/search/search_context";
import { SEARCH_ACTIONS } from "PFReducers/search_reducer/search_reducer";
import { KnownFiltersV2 } from "PFTypes/filters_v2";

import { useMatchesMetaWithKeywordFilters } from "../hooks/use_matches_meta_with_keyword_filters";
import { activitiesListTab, matchesTab, profilesTab } from "../tabs_constants";
import { SearchFilters } from "./search_filters";

export const SearchPageFilters = () => {
  const dispatch = useSearchDispatch();
  const {
    search: {
      tab,
      matchesPending,
      matchesMeta,
      activitiesPending,
      allActivitiesMeta,
      profilesPending,
      profilesMeta
    }
  } = useSearchStoreContext();

  const matchesMetaWithKeywordFilters = useMatchesMetaWithKeywordFilters(matchesMeta);

  return (
    <>
      {tab === matchesTab && (
        <SearchFilters
          omitInSidePanel={[KnownFiltersV2.Skills]}
          pending={matchesPending}
          meta={matchesMetaWithKeywordFilters}
          applyRequestFilters={(payload) => {
            dispatch({ type: SEARCH_ACTIONS.SEARCH_MERGE_MATCHES_REQUEST_FILTERS, payload });
          }}
          applyOrder={(payload) => {
            dispatch({ type: SEARCH_ACTIONS.SEARCH_MERGE_MATCHES_REQUEST_ORDER, payload });
          }}
        />
      )}

      {activitiesListTab.includes(tab) && (
        <SearchFilters
          key={tab}
          omitCompletely={[KnownFiltersV2.TemplateKey]} // template key is managed by tab
          pending={activitiesPending}
          meta={allActivitiesMeta?.[tab]}
          applyRequestFilters={(payload) => {
            dispatch({
              type: SEARCH_ACTIONS.SEARCH_MERGE_ACTIVITIES_REQUEST_FILTERS,
              payload
            });
          }}
          applyOrder={(payload) => {
            dispatch({
              type: SEARCH_ACTIONS.SEARCH_MERGE_ACTIVITIES_REQUEST_ORDER,
              payload
            });
          }}
        />
      )}

      {tab === profilesTab && (
        <SearchFilters
          pending={profilesPending}
          meta={profilesMeta}
          applyRequestFilters={(payload) => {
            dispatch({ type: SEARCH_ACTIONS.SEARCH_MERGE_PROFILES_REQUEST_FILTERS, payload });
          }}
          applyOrder={(payload) => {
            dispatch({ type: SEARCH_ACTIONS.SEARCH_MERGE_PROFILES_REQUEST_ORDER, payload });
          }}
        />
      )}
    </>
  );
};
